import { useEffect } from "react";

const useBlockThreeFingerSwipe = () => {
  useEffect(() => {
    const preventGesture = (e) => {
      if (e.touches && e.touches.length >= 3) {
        e.preventDefault();
      }
    };

    document.addEventListener("touchmove", preventGesture, { passive: false });
    document.addEventListener("touchstart", preventGesture, { passive: false });

    return () => {
      document.removeEventListener("touchmove", preventGesture);
      document.removeEventListener("touchstart", preventGesture);
    };
  }, []);
};

export default useBlockThreeFingerSwipe;
